import { DisplayCompany } from 'codegen';
import { TEditableColumn, TFieldProps } from 'types';

export const columns: TEditableColumn<DisplayCompany>[] = [{
  width: 100,
  title: 'ID',
  dataIndex: 'id',
}, {
  title: 'English Name',
  dataIndex: 'englishName',
  field: {
    type: TFieldProps.type.Text,
    placeholder: 'Enter english name',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}, {
  title: 'French Name',
  dataIndex: 'frenchName',
  field: {
    type: TFieldProps.type.Text,
    placeholder: 'Enter french name',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}];
